import React from 'react';
import PropTypes from 'prop-types';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';

const Maps = withScriptjs(
  withGoogleMap(({ isMarkerShown }) => {
    return (
      <div>
        <GoogleMap
          defaultZoom={15}
          defaultCenter={{ lat: 43.725485, lng: 7.414058 }}
        >
          {isMarkerShown && (
            <Marker position={{ lat: 43.724648, lng: 7.418056 }} />
          )}
        </GoogleMap>
      </div>
    );
  })
);

Maps.propTypes = {
  isMarkerShown: PropTypes.bool.isRequired,
};

const MapsComponent = ({ width, height, isMarkerShown }) => {
  return (
    <div
      style={{
        width: width,
      }}
    >
      <Maps
        isMarkerShown={isMarkerShown}
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDNtPK0Z-b8P2LlnJ9-CF0h4pi5O2eXFyc&v=3.exp&libraries=geometry,drawing,places"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: height }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    </div>
  );
};

MapsComponent.defautlProps = {
  width: '100%',
  height: '400px',
};

MapsComponent.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  isMarkerShown: PropTypes.bool,
};

export default MapsComponent;



// WEBPACK FOOTER //
// ./src/components/Main/contact/MapsComponent.js